import { CopyIconWithText } from "@/components/CopyIconWithText";
import { Icon } from "@/components/Icon";
import { LayoutWithHeader } from "@/components/Layout";
import { toMoney } from "@/utils/tool";
import { Button, Space } from "antd-mobile";
import styles from "./index.module.scss";
import { useSetup } from "./logic";
export const PagePayOrder = () => {
  const logic = useSetup();
  return <LayoutWithHeader title={"我的订单"} data-sentry-element="LayoutWithHeader" data-sentry-component="PagePayOrder" data-sentry-source-file="index.tsx">
      <Space className={styles.orderNo} align="center" justify="center" block data-sentry-element="Space" data-sentry-source-file="index.tsx">
        <span className={styles.orderNoLabel}>订单编号:</span>
        <CopyIconWithText text={logic.serach.get("orderNo") || ""} data-sentry-element="CopyIconWithText" data-sentry-source-file="index.tsx" />
      </Space>
      <Space align="baseline" justify="center" block data-sentry-element="Space" data-sentry-source-file="index.tsx">
        <div className={styles.amountLabel}>支付金额</div>
        <span className={styles.amount}>
          {logic.serach.get("amount") || ""}
        </span>
        <Icon name="vcoin" size={"28px"} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
      </Space>
      <p className={styles.tips}>提示：为确保您的资金安全，请不要私下交易转账，如造成资金损失则自行承担后果。</p>
      <Button className={styles.payit} onClick={logic.toPay} data-sentry-element="Button" data-sentry-source-file="index.tsx">
        支付
      </Button>
    </LayoutWithHeader>;
};